"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfManualVerificationDto = instanceOfManualVerificationDto;
exports.ManualVerificationDtoFromJSON = ManualVerificationDtoFromJSON;
exports.ManualVerificationDtoFromJSONTyped = ManualVerificationDtoFromJSONTyped;
exports.ManualVerificationDtoToJSON = ManualVerificationDtoToJSON;
exports.ManualVerificationDtoToJSONTyped = ManualVerificationDtoToJSONTyped;
/**
 * Check if a given object implements the ManualVerificationDto interface.
 */
function instanceOfManualVerificationDto(value) {
    return true;
}
function ManualVerificationDtoFromJSON(json) {
    return ManualVerificationDtoFromJSONTyped(json, false);
}
function ManualVerificationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'manualClearanceProvider': json['manualClearanceProvider'] == null ? undefined : json['manualClearanceProvider'],
    };
}
function ManualVerificationDtoToJSON(json) {
    return ManualVerificationDtoToJSONTyped(json, false);
}
function ManualVerificationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'manualClearanceProvider': value['manualClearanceProvider'],
    };
}
//# sourceMappingURL=ManualVerificationDto.js.map